export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";